export default __webpack_public_path__ + "assets/rewards-placeholder.dd4542b9a698588f2294ec294cd7b3c9.png";